export function getFunctionName() {
  const e = new Error('functionName')
  try {
    let functionName = ''
    // Split the stack trace into an array of lines by new line character
    const lines = (e.stack ?? '').split('\n').map((line) => line.trim())

    // A frame that names the function that called it reads "at Name (" or "at async Name ("
    // or "at new Name (". A frame with no such name marks where the call stack leaves user
    // code: a bare "at <file>:<line>:<col>" — native ESM's unlabeled module-top-level frame,
    // or an anonymous callback (e.g. a test runner's `it(name, function () {...})` body) —
    // or one of Node's CJS wrapper labels, which are never a real function name:
    // "Object.<anonymous>" (the CommonJS module wrapper) and "processTicksAndRejections"
    // (the microtask resume point after an awaited call).
    const isBoundaryFrame = (line: string) =>
      !/^at (async )?(new )?[\w$]+(\.[\w$<>]+)* \(/.test(line) ||
      /^at (Object\.<anonymous>|processTicksAndRejections) /.test(line)

    const boundaryIndex = lines.findIndex((line, i) => i > 0 && isBoundaryFrame(line))

    // The caller's frame sits one line above the boundary. An awaited call can truncate the
    // stack before any boundary frame is captured at all — in that case the last frame in the
    // trace IS the caller.
    const callerLine = boundaryIndex === -1 ? lines[lines.length - 1] : lines[boundaryIndex - 1]

    if (!callerLine) return ''

    const functionMatch = callerLine.match(/at (?:async )?(?:new )?([\w.]+) /)

    if (functionMatch && functionMatch[1]) {
      functionName = functionMatch[1]
    }

    return functionName
  } catch {
    return ''
  }
}
